import { render, staticRenderFns } from "./bankCode.vue?vue&type=template&id=2066ef47"
import script from "./bankCode.vue?vue&type=script&lang=js"
export * from "./bankCode.vue?vue&type=script&lang=js"
import style0 from "./bankCode.vue?vue&type=style&index=0&id=2066ef47&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports